import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

import { LayoutComponent } from './layout.component';
import { WebStoriesLayoutComponent } from './web-stories-layout/web-stories-layout.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { ScrollSpyDirective } from './scroll-top/scroll-spy.directive';
import { IconsModule } from 'app/icons/icons.module';

const components = [
	LayoutComponent,
	FooterComponent,
	HeaderComponent,
	ScrollTopComponent,
	CookiePolicyComponent,
	WebStoriesLayoutComponent,
];

const matModules = [MatSidenavModule, MatSnackBarModule, MatButtonModule];

@NgModule({
	imports: [RouterModule, CommonModule, FlexLayoutModule, IconsModule, ...matModules],
	exports: [LayoutComponent, WebStoriesLayoutComponent],
	declarations: [...components, ScrollSpyDirective],
	providers: [{ provide: 'Window', useValue: window }],
})
export class LayoutModule {}
